// 订单管理-->协议维护信息-->中英文
export const customerAgreementLocale = {
    'zhCN': {
        public: {
            whetherDelete: '确定删除？',
            importTemplate: '客户协议维护模板下载'
        },
        customerAgreement: {
            shipperName: '货主名称',
            customerProvinceCity: '客户省份/城市',
            provinceName: '省份',
            cityName: '城市',
            customerName: '客户名称',
            contractorName: '授权采购人',
            paymentDays: '账期（天）',
            startTime: '起始时间',
            endTime: '截止时间',

            effective: '有效',
            beOverdue: '过期',
            uneffective: '无效',

            customerAgreementManagement: '协议维护',
            customerAgreementDetail: '协议明细',

            // 验证相关
            shipperNameEmpty: '货主名称不能为空',
            customerNameEmpty: '客户名称不能为空',
            contractorNameEmpty: '授权采购人不能为空',
            paymentDaysValidate: '最大支持9位整数',
            startTimeIsNotNull: '起始时间不能为空',
            endTimeGreaterThanStartTime: '起始时间不能大于截止时间'
        }
    },
    'enUS': {
        public: {
            whetherDelete: 'Confirm delete?',
            importTemplate: 'Customer agreement maintenance template download'
        },
        customerAgreement: {
            shipperName: 'Shipper name',
            customerProvinceCity: 'Customer province/city',
            provinceName: 'Province',
            cityName: 'City',
            customerName: 'Clients name ',
            contractorName: 'Authorized purchaser',
            paymentDays: 'Account period (days)',
            startTime: 'Start time',
            endTime: 'Deadline',
            effective: 'Effective',
            beOverdue: 'BeOverdue',
            customerAgreementManagement: 'Protocol maintenance',
            customerAgreementDetail: 'Agreement details',
            // 验证相关
            shipperNameEmpty: 'The Shipper Name Cannot Be Empty',
            contractorNameEmpty: 'Authorized purchaser cannot be empty',
            customerNameEmpty: 'Customer name cannot be empty',
            paymentDaysValidate: 'Maximum support for 9-bit integers',
            startTimeIsNotNull: 'Start time cannot be empty',
            endTimeGreaterThanStartTime: 'Start time cannot be greater than the cutoff time'
        }
    }
}
export default customerAgreementLocale



// WEBPACK FOOTER //
// ./src/locale/modules/customerAgreementLocale.js